var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUnbatch = function SvgUnbatch(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.73828H21.7501",
    stroke: "#F1585E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76402 5.74253V3.37127C6.76402 2.74237 7.00693 2.13923 7.4393 1.69453C7.87168 1.24983 8.45811 1 9.06959 1H13.6739C13.9768 0.99977 14.2768 1.06093 14.5567 1.18C14.8367 1.29906 15.091 1.47369 15.3053 1.69391C15.5196 1.91412 15.6895 2.17561 15.8055 2.46342C15.9215 2.75123 15.9812 3.05972 15.9812 3.37127V5.74253M19.4446 5.74253V22.3432C19.4446 22.9721 19.2017 23.5752 18.7694 24.0199C18.337 24.4646 17.7506 24.7144 17.1391 24.7144H5.61123C4.99976 24.7144 4.41333 24.4646 3.98095 24.0199C3.54857 23.5752 3.30566 22.9721 3.30566 22.3432V5.74253H19.4446Z",
    stroke: "#F1585E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06934 11.6719V18.7857",
    stroke: "#F1585E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6807 11.6719V18.7857",
    stroke: "#F1585E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnbatch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Unbatch.43fc70b2.svg";
export { ForwardRef as ReactComponent };